import * as amplitude from '@amplitude/analytics-browser';
import { createSentryAngularAdapter } from './SentryAngularAdapter';
(function () {
  angular.module('leanlaw.core').run(['$rootScope', '$state', 'tracking', appStart]).factory('tracking', ['$state', '$window', 'userService', 'leanLawAuth', '$rootScope', trackingService]);
  let _tracking = false;
  let _track = null;
  function appStart($rootScope, $state, tracking) {
    $rootScope.$on('$stateChangeStart', (evt, to, params) => {
      if (!to.redirectTo) {
        tracking.page(to, params);
      }
    });
  }
  function trackingService($state, $window, userService, leanLawAuth, $rootScope) {
    userService.me().then(me => {
      const isTrackerAllowed = me.features.tracking || me.company.status !== 'test' && me.company.status !== 'internal';
      _tracking = Boolean(me.configuration.amplitude) && isTrackerAllowed && !me.impersonation;
      console.log('[tracking] bootstrap', {
        trackingEnabled: _tracking,
        hasAmplitudeKey: Boolean(me.configuration.amplitude),
        companyStatus: me.company.status,
        impersonation: Boolean(me.impersonation),
        sentryDsnInjected: typeof __SENTRY_DSN__ !== 'undefined' && Boolean(__SENTRY_DSN__),
        sentryReleaseInjected: typeof __SENTRY_RELEASE__ !== 'undefined' ? __SENTRY_RELEASE__ : 'unknown'
      });
      if (_tracking) {
        initializeTracking(me);
      }
    });
    return {
      page: trackPage,
      event: trackEvent
    };
    async function initializeTracking(me) {
      const companyData = createCompanyData(me.company);
      const userData = createUserData(me, companyData);
      _track = initializeAmplitudeDirect(me, companyData);
      // Await Sentry initialization to ensure state change handler is registered
      // before any state changes occur during app startup
      await initializeSentry(userData, me);
      // Track initial page
      trackPage($state.current, $state.params);
    }
    function createUserData(me, companyData) {
      const email = me.email.toLowerCase();
      return {
        myleanlawId: me.id,
        name: me.name,
        email,
        role: me.role,
        created_at: me.started,
        registrant: me.registrant,
        impersonation: me.impersonation,
        ...companyData
      };
    }
    function createCompanyData(company) {
      return {
        group_type: 'Company',
        group_value: company.id,
        companyName: company.name,
        companyId: company.id,
        companyStatus: company.status
      };
    }

    // Amplitude is analytics/metrics only — session replay is handled solely by
    // Sentry (see SentryService)
    function initializeAmplitudeDirect(me, companyData) {
      const email = me.email.toLowerCase();
      amplitude.init(me.configuration.amplitude, email, {
        defaultTracking: false
      });
      amplitude.setUserId(email);
      amplitude.identify(new amplitude.Identify().set('email', email).set('role', me.role).set('name', me.name).set('myLeanlawId', me.id).set('registrant', me.registrant));
      amplitude.setGroup('Company', companyData.companyId);
      amplitude.groupIdentify('Company', companyData.companyId, new amplitude.Identify().set('companyStatus', companyData.companyStatus).set('companyId', companyData.companyId).set('companyName', companyData.companyName));
      return (ev, p) => {
        try {
          amplitude.track(ev, p);
        } catch (e) {
          console.warn('Amplitude tracking error', e);
        }
      };
    }
    async function initializeSentry(userData, me) {
      console.log('[tracking] initializeSentry() start');

      // Create Angular adapter for Sentry v8
      const sentryAdapter = createSentryAngularAdapter($window, $state, leanLawAuth);

      // Initialize with user data and feature flags
      await sentryAdapter.initialize(userData, me);

      // Setup state change tracking
      const stateChangeHandler = sentryAdapter.getStateChangeHandler();
      if (stateChangeHandler) {
        $rootScope.$on('$stateChangeStart', stateChangeHandler);
        console.log('[tracking] Sentry stateChange handler registered');
      } else {
        console.warn('[tracking] Sentry stateChange handler missing after initialization');
      }
    }
    function trackPage(state) {
      if (!_tracking || !state.name) return;
      const name = state.track || state.name;
      const path = $window.location.hash.substring(1);
      if (_track) {
        try {
          amplitude.track('Viewed ' + name, {
            path,
            url: `https://myleanlaw.co${path}`,
            state: state.name,
            source: leanLawAuth.source,
            name
          });
        } catch (e) {
          console.warn('Amplitude tracking error', e);
        }
      }
    }
    function trackEvent(category, action, params) {
      if (!_tracking) return;
      const ev = action ? `${category} ${action}` : category;
      track(ev, params);
    }
    function track(ev, params) {
      const p = params || {};
      p.source = leanLawAuth.source;
      if (_track) {
        _track(ev, p);
      }
    }
  }
})();